import moment from "moment";

export const parseNoteDate = (date) => {
  const parsed = moment(date);

  if (parsed.isValid()) return parsed;

  return moment(date, "DD-MM-YYYY HH:mm");
};

export const formatNoteContent = (note) => {
  const date = note.startTime || note.created;
  const parsed = parseNoteDate(date);
  const formattedDate = parsed.isValid() ? parsed.format("DD-MM-YYYY") : "Date unknown";
  const noteLines = (note.note || "")
    .split("\n")
    .map((line) => `<p>${line || "<br>"}</p>`)
    .join("");

  return `<p><strong>Consultation Note (${formattedDate}):</strong></p>${noteLines}<p>---</p>`;
};

export const formatPrescriptionContent = (prescription) => {
  const medications = prescription.medications || [];
  const medicationList =
    medications.length > 0
      ? medications
          .map((med) => {
            const name = med.tradeName || med.genericName || "N/A";
            const type = med.acuteLongTerm || med.usageType || "";
            const datePrescribed = med.prescribedDate || med.startDate;
            const details = [
              med.dosage ? `<strong>Dosage:</strong> ${med.dosage}` : null,
              med.form ? `<strong>Form:</strong> ${med.form}` : null,
              med.frequency
                ? `<strong>Frequency:</strong> ${med.frequency}`
                : null,
              med.route ? `<strong>Route:</strong> ${med.route}` : null,
              med.duration
                ? `<strong>Duration:</strong> ${med.duration}${
                    med.durationFormat ? ` ${med.durationFormat}` : ""
                  }`
                : null,
              med.quantity
                ? `<strong>Quantity:</strong> ${med.quantity}`
                : null,
              med.repeat ? `<strong>Repeats:</strong> ${med.repeat}` : null,
              datePrescribed
                ? `<strong>Date Last Prescribed:</strong> ${moment(
                    datePrescribed
                  ).format("DD-MM-YYYY")}`
                : null,
              type ? `<strong>Type:</strong> ${type}` : null,
            ]
              .filter(Boolean)
              .join(" &nbsp;|&nbsp; ");
            return `<li><strong>${name}</strong>${
              details
                ? ` &mdash; <span style="font-size:13px">${details}</span>`
                : ""
            }</li>`;
          })
          .join("")
      : "<li>No medications</li>";

  return `<p><strong>Prescription (${moment(
    prescription.datePrescribed || prescription.created
  ).format("DD-MM-YYYY")}):</strong></p>
${prescription.note ? `<p><em>Note: ${prescription.note}</em></p>` : ""}
<p><strong>Medications:</strong></p>
<ul>${medicationList}</ul>
<p>---</p>
`;
};
